import React, { useState } from "react";
import { Tag, Space, Button, Popconfirm, Dropdown } from "antd";
import {
  EditOutlined,
  DeleteOutlined,
  DownOutlined,
  SafetyCertificateOutlined,
} from "@ant-design/icons";
import DataTable from "../../components/DataTable";
import { renderTags } from "../../components/RenderTags";

export default function DGHelperUsersTable({
  data,
  loading,
  page,
  pageSize,
  onPageChange,
  rolesList,
  isRoleUser,
  onChangeRole,
  onEditUser,
  onDeleteUser,
  onManagePermissions,
}) {
  const [updatingRoleId, setUpdatingRoleId] = useState(null);

  const columns = [
    {
      title: "Username",
      dataIndex: "name",
      key: "name",
      width: "15%",
      render: (_, record) => record.name || record.username,
      sorter: (a, b) => (a.name || "").localeCompare(b.name || ""),
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      width: "25%",
      sorter: (a, b) => (a.email || "").localeCompare(b.email || ""),
    },
    {
      title: "Role",
      key: "role",
      width: "15%",
      render: (_, record) => {
        const roleName = record.roles?.[0]?.name || "";
        if (!roleName) return <span style={{ color: "#aaa" }}>-</span>;
        if (isRoleUser) {
          return (
            <Tag color={roleName === "CDO" ? "#49627a" : "#2b751d"}>
              {roleName}
            </Tag>
          );
        }
        return (
          <Dropdown
            menu={{
              items: rolesList.map((r) => ({
                key: r.id || r.name,
                label: r.displayName || r.name,
                onClick: () => onChangeRole(record.id, r.name),
              })),
            }}
            trigger={["click"]}
          >
            <Tag
              style={{
                cursor: "pointer",
                opacity: updatingRoleId === record.id ? 0.5 : 1,
              }}
            >
              {updatingRoleId === record.id ? (
                "Updating..."
              ) : (
                <>
                  {roleName} <DownOutlined />
                </>
              )}
            </Tag>
          </Dropdown>
        );
      },
    },
    {
      title: "Permissions",
      key: "permissions",
      width: "30%",
      render: (_, record) => {
        const permNames = (record.permissions || [])
          .map((p) => p.name)
          .filter(Boolean);
        return renderTags(permNames, () => "#2b751d");
      },
    },
  ];

  if (!isRoleUser) {
    columns.push({
      title: "Actions",
      key: "actions",
      width: "15%",
      render: (_, record) => (
        <Space size="small">
          <Button
            type="text"
            icon={<SafetyCertificateOutlined />}
            onClick={() => onManagePermissions(record)}
            style={{ color: "#722ed1" }}
            title="Manage Permissions"
          />
          <Button
            type="text"
            icon={<EditOutlined />}
            onClick={() => onEditUser(record)}
            style={{ color: "#e29b45" }}
            title="Edit User"
          />
          <Popconfirm
            title="Delete User"
            description={`Are you sure you want to delete "${record.name || record.username}"?`}
            onConfirm={() => onDeleteUser(record.id)}
            okText="Yes"
            cancelText="No"
            okButtonProps={{ danger: true }}
          >
            <Button
              type="text"
              danger
              icon={<DeleteOutlined />}
              title="Delete User"
            />
          </Popconfirm>
        </Space>
      ),
    });
  }

  return (
    <DataTable
      rowKey="id"
      columns={columns}
      data={data}
      loading={loading}
      page={page}
      pageSize={pageSize}
      onPageChange={onPageChange}
    />
  );
}
